var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cloneView" }, [
    _c("div", { staticClass: "imagesWrapper" }, [
      _c("img", {
        staticClass: "originalImage",
        attrs: { src: _vm.productImage },
      }),
      _vm._v(" "),
      _c("img", { staticClass: "copyImage", attrs: { src: _vm.productImage } }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "textWrapper" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.$t("dialogTextClone")) + "\n\t"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }